export function orderCreatedRoute(orderId, isGuest) {
  return isGuest ? `/guest-order/${orderId}/success` : `/orders/${orderId}/success`;
}
